/**
 * @ngdoc directive
 * @name vLazy
 * @example this should only be added once on <body> tag
 * @returns {boolean}
 */

import extend from "../../services/extend";

export default (vue) => extend(vue, (vue) => {
    return {
        slug: null,
        init() {
            let picture = new Image();
            picture.onload = () => {
                this.load(picture.width > 0 && picture.height > 0);
            };
            picture.onerror = () => {
                this.load(false);
            };
            picture.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
        },
        load(sWebP) {

            if (!("IntersectionObserver" in window)) {
                return false;
            }

            let items = document.querySelectorAll("[data-src]");

            let observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio > 0) {
                        let item = entry.target;

                        let lazyImage = entry.target;
                        let showWebP = sWebP && lazyImage.dataset.hasOwnProperty('webp') && lazyImage.dataset.webp === 'true';
                        let imageSrc = showWebP ? lazyImage.dataset.src.replace(/(jpg|jpeg|png)$/, 'webp') : lazyImage.dataset.src;

                        if ( item.tagName.toLowerCase() === 'img' && entry.target.parentNode.tagName.toLowerCase() !== 'picture') {
                            if (item.dataset.hasOwnProperty('src')) {
                                item.src = imageSrc;
                            }
                        }
                        if ( item.tagName.toLowerCase() === 'svg' || item.tagName.toLowerCase() === 'div') {
                            if ( item.dataset.hasOwnProperty('src')) {
                                item.style.backgroundSize = "cover";
                                item.style.backgroundImage = "url('" + imageSrc + "')";
                            }
                        }
                        delete item.dataset.src;
                        observer.unobserve(item);
                    }
                });
            });

            items = Array.prototype.slice.call ( items );

            items.forEach((item) => {
                observer.observe(item);
            });

        }

    }

});